// reacttour/OnboardingTourNavigation.js - Previous / Next / Done under each walkthrough step
import React, { useEffect } from "react";
import { setupTourKeyboardControls } from "./OnboardingTourKeyboardControls";

export const TourNavigation = ({
  currentStep,
  steps,
  setCurrentStep,
  setIsOpen,
}) => {
  // @reactour/tour passes `steps` but no `stepsLength` (the logistics-workflow copy read one, so its last step never
  // showed "Done" and the arrow keys could run past the end).
  const stepsLength = steps?.length || 0;
  const step = steps?.[currentStep];

  // ✅ Attach keyboard controls
  useEffect(() => {
    const cleanup = setupTourKeyboardControls({
      currentStep,
      stepsLength,
      setCurrentStep,
      setIsOpen,
    });

    return cleanup;
  }, [currentStep, stepsLength, setCurrentStep, setIsOpen]);

  // ✅ Respect hideFooter per step
  if (step?.hideFooter) {
    return null;
  }

  const isLast = currentStep === stepsLength - 1;

  return (
    <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
      
      {/* Previous Button */}
      {currentStep > 0 && (
        <button
          onClick={() => setCurrentStep(currentStep - 1)}
          style={navBtnStyle}
        >
          ← Previous
        </button>
      )}

      {/* Next or Done */}
      {!isLast ? (
        <button
          onClick={() => setCurrentStep(currentStep + 1)}
          style={navBtnStyle}
        >
          Next →
        </button>
      ) : (
        <button
          onClick={() => setIsOpen(false)}
          style={navBtnStyle}
        >
          Done ✅
        </button>
      )}
    </div>
  );
};

const navBtnStyle = {
  padding: "10px 18px",
  borderRadius: 8,
  border: "1px solid #dcdcdc",
  background: "#fff",
  color: "#333",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "1rem",        // readable on mobile
  minHeight: 44,           // iOS/Android touch target minimum
  minWidth: 80,
  WebkitTapHighlightColor: "transparent",
};
